import React, { useEffect, useState } from "react";
import { RoleResponseModel } from "../../_core/_model";
import { useAppContext } from "../../context/AppContext.tsx";
import { AutoSelectDropdown, ddItem } from "./AutoSelectDropdown.tsx";
import { allAccessRoleID } from "../../Constants.ts";
import { FaInfoCircle } from "react-icons/fa";
import TooltipButton from "./TooltipButton.tsx";
import RoleDetailsOnTitle from "../Roles/RoleDetailsOnTitle.tsx";

interface request {
    skipItems: string[];
    initSelect: string,
    updateRole: (id: number) => void,
    dimensionCode: string
}

export function RolesDD({ skipItems, initSelect, updateRole, dimensionCode }: request) {
    const [filterdRoles, setRoles] = useState<RoleResponseModel[]>([]);
    const { roles } = useAppContext();

    useEffect(() => {
        applySkipFilter(roles);
    }, [skipItems]);

    const applySkipFilter = (allRoles: RoleResponseModel[]) => {
        const filtered = allRoles.filter(
            (x) => (typeof skipItems != 'undefined' && x.roleID != null) ? !skipItems.includes(x.roleID.toString()) : x
        );
        setRoles(filtered);
    };

    const handleSelect = (v: any) => {
        updateRole(v)
    };

    const filteredItem: ddItem[] = (typeof dimensionCode != 'undefined' && dimensionCode != "") ?
        filterdRoles?.filter((x) => x.dataMapCode == dimensionCode).filter((x) => allAccessRoleID[dimensionCode] != x.roleID).map((x) => (x.roleID == null) ? ({
            id: "",
            name: x.roleName,
        }) : ({
            id: x.roleID.toString(),
            name: x.roleName,
        })) : filterdRoles?.map((x) => (x.roleID == null) ? ({
            id: "",
            name: x.roleName,
        }) : ({
            id: x.roleID.toString(),
            name: x.roleName,
        }));

    return (
        <AutoSelectDropdown
            placeholder="Select a Role"
            emptyString="Role not available"
            options={filteredItem}
            initSelect={initSelect}
            onSelect={handleSelect}
            disabled={false}
            optionDetails={(role) =>
                <TooltipButton maxWidth={750}  title={() =>
                    role.id == null ? (
                        ""
                    ) : (
                        <RoleDetailsOnTitle roleId={role.id.toString()} />
                    )
                }>
                    <FaInfoCircle
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    />
                </TooltipButton>
            }
        />
    );
}

export default RolesDD;
